import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  height: 242px;
  /* width: 100%; */
  padding: 27px 9px 34px 11px;
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  max-width: 100vw;
  overflow: hidden;
  margin-bottom: 36px;
  @media (min-width: 1390px) {
    margin-right: 44px;
    max-width: calc(50% - 22px);
  }
`;

const Title = styled.div`
  font-style: normal;
  letter-spacing: 0.01em;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
  margin: -27px -9px 27px -11px;
  // margin-bottom: 15px;
  height: 42px;
  padding-left: 17px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
`;

const LabelText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.01em;
  color: ${Colors.text_on_primary};
  margin-right: 9px;
`;

const LabelColorCircle = styled.div`
  position: relative;
  height: 9px;
  width: 9px;
  margin-right: 5px;

  &::before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    border: 1px solid ${Colors.text_on_primary};
  }

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ChartWrapper = styled.div`
  @media (min-width: 1390px) {
    max-width: 93%;
  }
`;

export default {
  Container,
  Title,
  LabelText,
  LabelColorCircle,
  LabelWrapper,
  ChartWrapper,
};
